var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgManWalking = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10.056,
    height: 15.259,
    viewBox: "0 0 10.056 15.259",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-560.169 -2552.241)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-walking",
    "data-name": "Icon awesome-walking",
    d: "M5.793,2.673A1.337,1.337,0,1,0,4.456,1.337,1.337,1.337,0,0,0,5.793,2.673ZM8.425,6.825,7.776,6.5l-.27-.819A3.036,3.036,0,0,0,4.66,3.564a6.123,6.123,0,0,0-2.6.7A2.656,2.656,0,0,0,.678,5.553l-.187.379a.894.894,0,0,0,.4,1.195.879.879,0,0,0,1.183-.4l.187-.379a.885.885,0,0,1,.459-.429l.746-.3L3.039,7.31a1.788,1.788,0,0,0,.415,1.637l1.668,1.821a1.8,1.8,0,0,1,.415.771l.51,2.041a.891.891,0,0,0,1.729-.432l-.618-2.478A1.781,1.781,0,0,0,6.743,9.9L5.476,8.515,5.955,6.6l.153.459a1.776,1.776,0,0,0,.883,1.03l.649.329a.879.879,0,0,0,1.183-.4.9.9,0,0,0-.4-1.2ZM2.051,10.743a1.728,1.728,0,0,1-.4.6l-1.392,1.4A.891.891,0,0,0,1.521,14l1.654-1.654a1.81,1.81,0,0,0,.4-.6l.376-.941c-1.54-1.679-1.078-1.164-1.32-1.5l-.576,1.434Z",
    transform: "translate(560.752 2552.741)",
    fill: "none",
    stroke: "#3d5567",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgManWalking, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/man-walking.9df97633.svg";
export { ForwardRef as ReactComponent };